module.exports = __webpack_public_path__ + "img/lx-img6.f6d604d6.png";